import * as React from 'react'
import { Button } from '../ui/button'
import { Separator } from '../ui/separator'
import { MicrosoftIcon, GoogleIcon } from './icons'

interface IProps {
	continueWithLabel: string
	microsoftAuthUrl: string
	googleAuthUrl: string
}

export default function SocialAuthButtons({ continueWithLabel, microsoftAuthUrl, googleAuthUrl }: IProps) {
	return (
		<>
			<div className="flex items-center gap-3 text-sm text-muted-foreground">
				<Separator className="shrink" />
				<span className="shrink-0">{continueWithLabel}</span>
				<Separator className="shrink" />
			</div>

			<div className="grid grid-cols-2 gap-3">
				<Button variant="outline" render={<a href={microsoftAuthUrl} />}>
					<MicrosoftIcon className="size-4" />
					Microsoft
				</Button>
				<Button variant="outline" render={<a href={googleAuthUrl} />}>
					<GoogleIcon className="size-4" />
					Google
				</Button>
			</div>
		</>
	)
}
